// extracted by mini-css-extract-plugin
export default {"productGrid":"J5-z","centerLink":"K5-z","productSection":"L5-z","item":"M5-z","ctaButton":"N5-z"};